<template>
  <div>
    <b-row v-if="layout == 'half'">
      <b-col  cols="12" md="6">
        <b-card>
          <div class="d-flex justify-content-between">
            <b-skeleton width="30%" height="30%"></b-skeleton>
            <b-skeleton width="20%" height="30%"></b-skeleton>
          </div>
          <b-row class="mt-3">
            <b-col v-for="h in half" :key="h">
              <product-item-skeleton />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col  cols="12" md="6">
        <b-card>
          <div class="d-flex justify-content-between">
            <b-skeleton width="30%" height="30%"></b-skeleton>
            <b-skeleton width="20%" height="30%"></b-skeleton>
          </div>
          <b-row class="mt-3">
            <b-col v-for="h in half" :key="h">
              <product-item-skeleton />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <div v-else>
      <b-card>
        <div class="d-flex justify-content-between mb-2">
          <b-skeleton width="30%" height="40%"></b-skeleton>
          <b-skeleton width="20%" height="30%"></b-skeleton>
        </div>
        <b-row no-gutters>
          <b-col cols="12" md="2">
            <b-skeleton-img no-aspect></b-skeleton-img>
          </b-col>
          <b-col cols="12" md="2" v-for="f in full" :key="f">
            <product-item-skeleton class="m-2" />
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard, BSkeleton, BSkeletonImg } from "bootstrap-vue";
import ProductItemSkeleton from "./ProductItemSkeleton.vue";
export default {
  components: {
    BCard,
    BSkeleton,
    ProductItemSkeleton,
    BSkeletonImg,
  },
  props: {
    layout: {
      type: String,
    },
  },
  data() {
    return {
      half: [1, 2, 3],
      full: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    };
  },
};
</script>

<style>
</style>
